import { getOrganisationsCurrentSavingsOpportunitiesSelector } from "./getOrganisationsCurrentSavingsOpportunitiesSelector";
import { RootState } from "../../store";
import { SavingsOpportunity } from "@/services/cloudchipr.api";

export const savingsOpportunitiesDataSelector = (
  state: RootState,
  resourceId?: string,
): SavingsOpportunity[] | undefined => {
  return getOrganisationsCurrentSavingsOpportunitiesSelector(resourceId)(state)
    ?.data;
};
